import { getPageData } from '../lib/api'
import Snackbar from '@material-ui/core/Snackbar';
import React from "react";
import { getCountries } from "../lib/magento-api"
import FormLoader from "../components/ui/FormLoader"
import Head from 'next/head'
import isMobileDetect from '/lib/services/helpers/isMobileDetect';
import { useContactUs } from '/lib/hooks/ContactUs/useContactUs';

import { useNotifyModal } from '/lib/hooks/useNotifyModal';
import dynamic from 'next/dynamic';
const NotifyModal = dynamic(() => import('/components/NotifyModal'))

function contactPage({ pageContent, countryData }) {
	const seo = pageContent?.seo || null
	pageContent = pageContent?.pwa || null

	const { showNotifyModal, handleModalClose } = useNotifyModal();

	const {
		showLoader,
		error,
		vertical,
		horizontal,
		open,
		errors,
		website_id,
		phoneRegExp,
		handleSnackClose,
		handleSubmit,
		onSubmit,
		register
	} = useContactUs()
	return (
		<>
			<Head>
				{(seo.title) ? (<title>{seo.title}</title>) : null}
				{(seo.title) ? (<meta name="title" content={seo.title} />) : null}
				{(seo.metaDesc) ? (<meta name="description" content={seo.metaDesc} />) : null}
				{(seo.metaKeywords) ? (<meta name="keywords" content={seo.metaKeywords} />) : null}
				{(seo.opengraphTitle) ? (<meta property="og:title" content={seo.opengraphTitle} />) : null}
				{(seo.opengraphDescription) ? (<meta property="og:description" content={seo.opengraphDescription} />) : null}
				{(seo.opengraphImage && seo.opengraphImage.sourceUrl) ? (<meta property="og:image" content={seo.opengraphImage.sourceUrl} />) : null}
				{(seo.twitterDescription) ? (<meta property="twitter:description" content={seo.twitterDescription} />) : null}
				{(seo.twitterTitle) ? (<meta property="twitter:title" content={seo.twitterTitle} />) : null}
				<link rel="stylesheet" href="/css/contact-us.css" />
			</Head>
			{showNotifyModal ? <NotifyModal
				handleModalClose={handleModalClose}
				className='notifyContent'
				isOpen={showNotifyModal}
			/> : null}
			<FormLoader show={showLoader} />
			<div dangerouslySetInnerHTML={{ __html: pageContent.section1 }} />
			{error && (
				<Snackbar
					autoHideDuration={1500}
					anchorOrigin={{ vertical, horizontal }}
					open={open}
					onClose={handleSnackClose}
					message={error}
					key={vertical + horizontal}
				/>
			)}
			<div className="container">
				<div className="mobile_contact_sec2">
					<h4>For product related & other queries</h4>
					<p>Please submit your question below and we will respond within 48hrs</p>
					<form onSubmit={handleSubmit(onSubmit)}>
						<div className="row">
							<div className="col-12 col-md-8">
								<div className="row">
									<div className="col-12 col-md-6">
										<div className="input_colm">
											<label htmlFor="fullName">Name<sup>*</sup></label>
											<input {...register("fullName", {
												required: {
													value: true,
													message: 'Name is required'
												},
												maxLength: {
													value: 40,
													message: 'Name can not be larger than 40 characters'
												}
											})}
												name="fullName"
												type="text"
											/>
											{errors?.fullName && (
												<div className="comm-error">
													{errors?.fullName.message}
												</div>
											)}
										</div>
									</div>
									<div className="col-12 col-md-6">
										<div className="input_colm">
											<label htmlFor="email">Registered Email ID <sup>*</sup></label>
											<input {...register("email", {
												required: {
													value: true,
													message: 'Email is required'
												},
												pattern: {
													value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
													message: 'Enter a valid email'
												}

											})}
												name="email"
												type="email"
											/>
											{errors?.email && (
												<div className="comm-error">
													{errors?.email.message}
												</div>
											)}
										</div>
									</div>
									<div className="col-12 col-md-6">
										<div className="input_colm">
											<label htmlFor="country">Country<sup>*</sup></label>
											<div className="input-select">
												<select
													{...register(`country`, {
														required: {
															value: true,
															message: "Country is required",
														},
													})}
													id='country'
													name='country'
												>
													<option value="">Select Country</option>
													{
														countryData?.map(function (element, index) {
															return (
																<option value={element.id} key={"country" + index}>{element.full_name_english}</option>
															)
														})
													}
												</select>
												{errors?.country && (
													<div className="comm-error">
														{errors?.country.message}
													</div>
												)}

											</div>
										</div>
									</div>
									<div className="col-12 col-md-6">
										<div className='input_colm'>
											<label htmlFor="postcode">Mobile Number<sup>*</sup></label>
											<div className='input_colm2'>
												{
													(website_id == 1) ? <ul>
														<li><img src="/images/flag-india.png" alt="flag icon" /> +91</li>
													</ul> : null
												}
												<div className="w-100">
													<input
														{...register("telephone", {
															required: {
																value: true,
																message: 'Phone number is required'
															},
															pattern: {
																value: phoneRegExp,
																message: `Phone number is not valid`
															}
														})}
														name="telephone"
														type="tel"
													/>
													{errors?.telephone && (
														<div className="comm-error">
															{errors?.telephone.message}
														</div>
													)}
												</div></div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-12 col-md-4">
								<div className="input_colm">
									<label htmlFor="message">Comments/queries<sup>*</sup></label>
									<textarea
										{...register("message", {
											required: {
												value: true,
												message: "Query is required",
											},
											minLength: {
												value: 6,
												message: 'Query must be at least 6 characters'
											},
											maxLength: {
												value: 200,
												message: 'Query can not be larger than 200 characters'
											}
										})}
										name="message"
										id="message"
									/>
									{errors?.message && (
										<div className="comm-error">
											{errors?.message.message}
										</div>
									)}
								</div>
							</div>
						</div>
						<div className="submit_colm">
							<button type="submit"> Submit</button>
						</div>
					</form>
				</div>
			</div>


		</>
	);
}

export async function getServerSideProps(ctx) {
	try {
		const { req, res } = ctx;
		const store =
			typeof req.cookies["store"] == "undefined" ? "" : req.cookies["store"];
		const pageContent = await getPageData("contact-us");
		const countryData = await getCountries(store);
		return {
			props: {
				isSsrMobile: isMobileDetect(req),
				pageContent, countryData
			}
		};
	} catch (error) {
		console.log('error in server side contact us', error);

		return {
			notFound: true,
			revalidate: 600,
		}
	}
}

export default contactPage;



